import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import fi from './locales/fi.json'
import ru from './locales/ru.json'
import uk from './locales/uk.json'
import he from './locales/he.json'
import de from './locales/de.json'
import pl from './locales/pl.json'
import et from './locales/et.json'
import { resolveInitialLocale, SUPPORTED_CODES } from './resolveLocale'

/**
 * UI strings only.
 *
 * There are two translation systems in this project and they are deliberately separate.
 * This one covers chrome the developer writes: buttons, labels, error messages. Content the
 * owner writes (cottage descriptions, attractions, activities) is translated in the database
 * and arrives already resolved from the API.
 *
 * The split matters because they change on completely different schedules. Shipping a new
 * button label is a deploy; adding a Polish description of the sauna is an afternoon in the
 * admin console, and must never require one.
 *
 * Plural rules come from Intl.PluralRules via i18next v21+, so Russian, Ukrainian and Polish
 * get their few/many forms and Hebrew its dual form without any custom code.
 */
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fi: { translation: fi },
    ru: { translation: ru },
    uk: { translation: uk },
    he: { translation: he },
    de: { translation: de },
    pl: { translation: pl },
    et: { translation: et },
  },
  // Resolved here, before React renders, rather than switched in an effect afterwards.
  // Initialising on 'en' and calling changeLanguage from a mount effect leaves the first
  // paint in English and relies on every subscribed component catching the change event.
  lng: resolveInitialLocale(),
  fallbackLng: {
    // Mirrors the API's fallback chain: a Ukrainian speaker reads Russian more easily
    // than English, so an untranslated string should land there first.
    uk: ['ru', 'en'],
    ru: ['uk', 'en'],
    default: ['en'],
  },
  supportedLngs: [...SUPPORTED_CODES],
  interpolation: {
    // React already escapes everything it renders.
    escapeValue: false,
  },
  returnNull: false,
  react: {
    // Re-render subscribed components on a language change and on a bundle load. Suspense is
    // off because every bundle is imported statically: there is nothing to suspend on, and
    // leaving it enabled makes a missed event look like a permanently pending boundary.
    bindI18n: 'languageChanged loaded',
    useSuspense: false,
  },
})

export default i18n
